<script>
  import { counter } from './scripts/stores.js';

  // not a perfect animation implementation, but it should fit for now.
  let animateClass = undefined;
  counter.subscribe((c) => {
    animateClass = c.increased;
    setTimeout(() => {
      animateClass = undefined;
    }, 1000);
  });
</script>

<nav>
  <div id="wrapper">
    <span id="correct" title="Correct: {$counter.correct}" class:correct-blur-out={animateClass === 'correct'}
      >Correct: {$counter.correct}</span
    >
    <span id="incorrect" title="Incorrect: {$counter.incorrect}" class:incorrect-blur-out={animateClass === 'incorrect'}
      >Incorrect: {$counter.incorrect}</span
    >
    <span id="remaining"
      >Remaining: {$counter.questions -
        $counter.correct -
        $counter.incorrect}</span
    >
  </div>
</nav>

<style>
  nav {
    width: 100%;
    position: fixed;
    z-index: 100;
    padding: 0 16px;
    background-color: #eee;
    box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%),
      0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
    top: 0;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  #wrapper {
    max-width: 1000px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  nav span {
    font-size: 150%;
    font-weight: bold;
  }

  #correct {
    color: darkgreen;
  }
  #incorrect {
    color: darkred;
  }
  #remaining {
    color: #222;
  }

  .correct-blur-out::after {
    content: attr(title);
    position: absolute;
    color: darkgreen;
    -webkit-animation: blur-out-expand 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      both;
    animation: blur-out-expand 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  .incorrect-blur-out::after {
    content: attr(title);
    position: absolute;
    color: darkred;
    -webkit-animation: blur-out-expand 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      both;
    animation: blur-out-expand 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  /* ----------------------------------------------
 * Generated by Animista on 2021-4-3 19:56:35
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation blur-out-expand
 * ----------------------------------------
 */
  @-webkit-keyframes blur-out-expand {
    0% {
      -webkit-filter: blur(0.01);
      filter: blur(0.01);
    }
    100% {
      letter-spacing: 0.8em;
      -webkit-filter: blur(12px) opacity(0%);
      filter: blur(12px) opacity(0%);
    }
  }
  @keyframes blur-out-expand {
    0% {
      -webkit-filter: blur(0.01);
      filter: blur(0.01);
    }
    100% {
      letter-spacing: 0.8em;
      -webkit-filter: blur(12px) opacity(0%);
      filter: blur(12px) opacity(0%);
    }
  }
</style>
